/**
 * Stable per-browser-tab id for CRM activity session / heartbeat dedupe.
 */

const STORAGE_KEY = 'lctf_crm_activity_tab_id';

function randomId(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return `tab_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 10)}`;
}

export function getCrmActivityTabId(): string {
  if (typeof sessionStorage === 'undefined') return randomId();
  try {
    const existing = sessionStorage.getItem(STORAGE_KEY);
    if (existing && existing.length > 0) return existing;
    const created = randomId();
    sessionStorage.setItem(STORAGE_KEY, created);
    return created;
  } catch {
    return randomId();
  }
}
